const registeredTables = new Set()
let listeningForTurboCache = false

export function createTurboDataTable(table, options, { legacy = false } = {}) {
  const $table = $(table)
  destroyExistingDataTable($table)
  exemptPageFromTurboCache()
  const dataTable = legacy ? $table.dataTable(options) : $table.DataTable(options)
  registerTurboDataTable(dataTable, $table, { loaded: !serverSideEnabled(options) })

  return dataTable
}

export function destroyTurboDataTable(dataTable, { clear = false } = {}) {
  const state = findState(dataTable)
  if (state) return destroyState(state, { clear })

  destroyDataTable(dataTable, { clear })
  return null
}

export function registerTurboDataTable(dataTable, table, { loaded = false } = {}) {
  const state = {
    dataTable,
    $table: table && table.jquery ? table : $(table),
    loaded,
    destroyed: false,
  }

  state.$table.on("draw.dt.datatablesTurbo", () => {
    state.loaded = true
  })

  registeredTables.add(state)
  ensureTurboCacheListener()

  return dataTable
}

function ensureTurboCacheListener() {
  if (listeningForTurboCache || typeof document === "undefined") return

  document.addEventListener("turbo:before-cache", prepareTablesForCache)
  listeningForTurboCache = true
}

function prepareTablesForCache() {
  Array.from(registeredTables).forEach((state) => {
    if (state.destroyed) return

    abortPendingRequest(state.dataTable)
    const loaded = state.loaded
    destroyState(state)
    if (!loaded) ensureLoadingRow(state)
  })
}

function destroyState(state, { clear = false } = {}) {
  if (state.destroyed) return null

  state.$table.off(".datatablesTurbo")
  abortPendingRequest(state.dataTable)
  destroyDataTable(state.dataTable, { clear })

  state.destroyed = true
  registeredTables.delete(state)
  return null
}

function exemptPageFromTurboCache() {
  if (typeof window === "undefined") return
  window.Turbo?.cache?.exemptPageFromCache?.()
}

function destroyExistingDataTable($table) {
  if (typeof $.fn === "undefined" || typeof $.fn.DataTable === "undefined") return
  if (typeof $.fn.DataTable.isDataTable !== "function" || !$.fn.DataTable.isDataTable($table)) return

  destroyTurboDataTable($table.DataTable())
}

function destroyDataTable(dataTable, { clear = false } = {}) {
  if (!dataTable) return

  try {
    if (clear && typeof dataTable.clear === "function") dataTable.clear()

    if (typeof dataTable.destroy === "function") {
      dataTable.destroy()
    } else if (typeof dataTable.fnDestroy === "function") {
      dataTable.fnDestroy()
    }
  } catch (_e) {
    // Turbo can call cache teardown close to normal page teardown.
  }
}

function abortPendingRequest(dataTable) {
  const settings = dataTableSettings(dataTable)
  const xhr = settings && settings.jqXHR

  if (xhr && xhr.readyState !== 4 && typeof xhr.abort === "function") {
    xhr.abort()
  }
}

function ensureLoadingRow(state) {
  const tbody = state.$table.find("tbody")[0]
  if (!tbody) return

  const columnCount = state.$table.find("thead th").length || 1
  tbody.innerHTML = `<tr><td class="dataTables_empty" colspan="${columnCount}">Loading...</td></tr>`
}

function dataTableSettings(dataTable) {
  if (!dataTable) return null
  if (typeof dataTable.settings === "function") return dataTable.settings()[0]
  if (typeof dataTable.fnSettings === "function") return dataTable.fnSettings()

  return null
}

function findState(dataTable) {
  const settings = dataTableSettings(dataTable)

  return Array.from(registeredTables).find((state) => {
    if (state.dataTable === dataTable) return true

    const stateSettings = dataTableSettings(state.dataTable)
    return settings && stateSettings && settings.nTable === stateSettings.nTable
  })
}

function serverSideEnabled(options) {
  return Boolean(options && (options.serverSide || options.bServerSide))
}
